<h2 mat-dialog-title>
  {{ data.mode === 'day' ? 'Dag kopiëren' : 'Week kopiëren' }}
</h2>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    <!-- Source picker -->
    <div class="space-y-2">
      <label class="block font-medium text-sm select-none" for="copy-source-input">
        Van
      </label>

      <mat-form-field subscriptSizing="dynamic" class="w-full max-w-80">
        <input
          id="copy-source-input"
          matInput
          [matDatepicker]="sourcePicker"
          [formControl]="sourceControl"
          [placeholder]="
            data.mode === 'day' ? 'Kies een datum' : 'Kies een dag in de bronweek'
          "
          readonly
        />
        <mat-datepicker-toggle matIconSuffix [for]="sourcePicker" />
        <mat-datepicker #sourcePicker />
      </mat-form-field>

      @if (data.mode === 'week' && sourceWeekLabel()) {
        <p class="week-range-label">
          <mat-icon class="week-range-icon">date_range</mat-icon>
          {{ sourceWeekLabel() }}
        </p>
      }
    </div>

    <!-- Target picker -->
    <div class="space-y-2">
      <label class="block font-medium text-sm select-none" for="copy-target-input">
        Naar
      </label>

      <mat-form-field subscriptSizing="dynamic" class="w-full max-w-80">
        <input
          id="copy-target-input"
          matInput
          [matDatepicker]="targetPicker"
          [matDatepickerFilter]="targetFilter()"
          [min]="today"
          [formControl]="targetControl"
          [placeholder]="
            data.mode === 'day' ? 'Kies een datum' : 'Kies een dag in de doelweek'
          "
          readonly
        />
        <mat-datepicker-toggle matIconSuffix [for]="targetPicker" />
        <mat-datepicker #targetPicker />
      </mat-form-field>

      @if (data.mode === 'week' && targetWeekLabel()) {
        <p class="week-range-label">
          <mat-icon class="week-range-icon">date_range</mat-icon>
          {{ targetWeekLabel() }}
        </p>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="cancel()">Annuleren</button>
  <button mat-button [disabled]="!canConfirm" (click)="confirm()">Kopiëren</button>
</mat-dialog-actions>
